import { Box, Typography } from "@mui/material";

const bonuses = [
  { count: 5, amount: "$50" },
  { count: 10, amount: "$150" },
  { count: 20, amount: "$500" },
  { count: 100, amount: "$2,500" },
];

export default function SpecialBonuses() {
  return (
    <Box
      sx={{
        borderRadius: 3,
        p: 3,
        maxWidth: 520,
        mb: 3,
        background: "linear-gradient(135deg, #f0fdf4 0%, #fefce8 100%)",
        border: "1px solid",
        borderColor: "#bbf7d0",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: 4,
          height: "100%",
          bgcolor: "#22c55e",
          borderRadius: "3px 0 0 3px",
        },
      }}
    >
      <Typography
        variant="subtitle2"
        gutterBottom
        sx={{ fontWeight: 700, color: "#15803d" }}
      >
        Special Bonuses ✨
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1.5, display: "block" }}
      >
        Hit these referral milestones to unlock extra cash rewards
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, mt: 1 }}>
        {bonuses.map((b) => (
          <Box
            key={b.count}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              maxWidth: 300,
              py: 0.5,
              borderBottom: "1px dashed",
              borderColor: "#bbf7d0",
              "&:last-child": { borderBottom: "none" },
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Refer {b.count} paying users
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 700, color: "#16a34a" }}
            >
              +{b.amount}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
